<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>POS Order Listing
        </h4>
        <div class="order-filter-bar">
          <!-- Search -->
          <div class="search-box">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control" placeholder="Search orders..." [(ngModel)]="searchQuery"
              (input)="onSearchChange()" />
          </div>

          <!-- Status Filter -->
          <div class="status-box">
            <i class="fa fa-filter"></i>
            <select class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
              <option value="all">All Status</option>
              <option *ngFor="let status of statusList.slice(1)" [value]="status">
                {{ getStatusLabel(status) }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Actions</th>
              <th scope="col">Order Number</th>
              <th scope="col">Status</th>
              <th scope="col">Total Amount</th>
              <th scope="col">User Name</th>
              <th scope="col">Desk</th>
              <th scope="col">Payment Type</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of orders">
              <td class="d-flex gap-23">
                <button class="btn btn-sm btn-primary" (click)="viewOrderDetails(order)" placement="top"
                  ngbTooltip="View details">
                  <i class="fa fa-eye"></i>
                </button>
                <button *ngIf="getAvailableActions(order).includes('accept')" class="btn btn-sm btn-success"
                  (click)="openModal('accept', order)" placement="top" ngbTooltip="Accept Order">
                  <i class="fa fa-check"></i>
                </button>
                <button *ngIf="getAvailableActions(order).includes('readyForPickup')"
                  class="btn btn-sm btn-info text-white" (click)="openModal('readyForPickup', order)" placement="top"
                  ngbTooltip="Ready for Pickup">
                  <i class="fa fa-truck"></i>
                </button>
                <button *ngIf="getAvailableActions(order).includes('complete')" class="btn btn-sm btn-primary"
                  (click)="openModal('complete', order)" placement="top" ngbTooltip="Complete Order">
                  <i class="fa fa-check-circle"></i>
                </button>
                <button *ngIf="getAvailableActions(order).includes('cancel')" class="btn btn-sm btn-danger"
                  (click)="openModal('cancel', order)" placement="top" ngbTooltip="Cancel Order">
                  <i class="fa fa-times"></i>
                </button>
              </td>
              <td>{{ order.orderNumber }}</td>
              <td>
                <span class="badge" style="
      border-radius: 20px;
      padding: 0 10px;
      font-size: 13px;
    " [ngClass]="getStatusBadgeClass(order.status)">
                  {{ statusLabelMap[order.status] || order.status }}
                </span>
              </td>
              <td class="text-danger font-bold">
                {{ order.currency }}
                {{ order.chargeableAmount / 100 | number: "1.2-2" }}
              </td>
              <td>{{ order.userName }}</td>
              <td>{{ order.deskId?.deskName || 'N/A' }}</td>
              <td>{{ order.paymentType | titlecase }}</td>
              <td>{{ order.created_at | date: "medium" }}</td>
            </tr>
            <tr *ngIf="orders?.length == 0 && !loading">
              <td colspan="8" class="text-center">No orders found</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="d-flex justify-content-center mt-5" *ngIf="orders?.length != 0">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)">
          </ngb-pagination>
        </div>
      </div>
      <div class="text-center p-4" *ngIf="loading">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>